import React from 'react';

// This page is loaded in the popup window after Google auth
// The parent window monitors the URL and extracts the session_id
// This component just shows a brief message before the popup closes

function AuthCallbackPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--background)]">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-[var(--primary)] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-lg font-medium">Completing sign in...</p>
        <p className="text-sm text-[var(--text-secondary)] mt-1">This window will close automatically</p>
      </div>
    </div>
  );
}

export default AuthCallbackPage;
